$(document).ready(function () {
    // Make sure idesConfig and idesConfig.resultCount are defined
    if (typeof idesConfig !== "undefined" && idesConfig.resultCount) {
        var idesCount = idesConfig.resultCount;

        // Hide all rows initially
        $(".ides-row").css("display", "none");

        // Expose Loadmore globally so it can be called via HTML onclick
        window.Loadmore = function () {
            // Select and show the required number of rows
            var rowsToShow = $("#listTable tbody tr.ides-row:lt(" + idesCount + ")");
            rowsToShow.css("display", "").removeClass("ides-row");

            // Update count
            var totalVisibleRows = $("#listTable tbody tr").not(".ides-row").length;
            $(".Countresult").html(totalVisibleRows);

            // Hide footer if no more hidden rows
            if ($("#listTable tbody tr.ides-row").length === 0) {
                $(".search-footer").hide();
            }
        };
    } else {
        console.warn("idesConfig.resultCount is not defined or is invalid.");
    }
});
